import { render, staticRenderFns } from "./Date.vue?vue&type=template&id=05ac91bb&scoped=true"
import script from "./Date.vue?vue&type=script&lang=js"
export * from "./Date.vue?vue&type=script&lang=js"
import style0 from "./Date.vue?vue&type=style&index=0&id=05ac91bb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ac91bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ac91bb')) {
      api.createRecord('05ac91bb', component.options)
    } else {
      api.reload('05ac91bb', component.options)
    }
    module.hot.accept("./Date.vue?vue&type=template&id=05ac91bb&scoped=true", function () {
      api.rerender('05ac91bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Date.vue"
export default component.exports